import type { AppShellContextConfiguration } from "../../../../../../shared/frontend/layout/appShellContext";
import { useI18n } from "../i18n/useI18n";
import { useGlobalStudioContext } from "../studios/useGlobalStudioContext";

const MIN_STUDIOS_FOR_SELECTOR = 2;
const ALL_STUDIOS_OPTION_VALUE = "__all";

/** Only scope data and actions; Shared owns the complete selection control. */
export function useStudioContextConfiguration(): AppShellContextConfiguration | undefined {
  const { text } = useI18n();
  const { optionsOnlyAllowed, studiosLoaded, selectedStudioIds, setSelectedStudioIds, scopeLabel, isAllStudios } = useGlobalStudioContext();
  if (!studiosLoaded || optionsOnlyAllowed.length < MIN_STUDIOS_FOR_SELECTOR) return undefined;
  return {
    mobilePicker: { label: text("Global studio scope aria"), icon: "EnvironmentOutlined" },
    selections: [{
      label: scopeLabel, ariaLabel: text("Global studio scope aria"), marker: "check",
      options: [
        { value: ALL_STUDIOS_OPTION_VALUE, label: text("All studios"), aggregate: true, checked: isAllStudios },
        ...optionsOnlyAllowed.map(option => ({ value: String(option.value), label: String(option.label), checked: selectedStudioIds.includes(String(option.value)) })),
      ],
      onChange: value => setSelectedStudioIds(value === ALL_STUDIOS_OPTION_VALUE ? [] : [value]),
    }]
  };
}
